/* istanbul ignore file */

import { getPadraoComRetorno, getPadraoBlobComRetorno, getPadrao } from 'services/api';
import { montarUrlFiltro } from 'utils/funcaoPadrao';
import { downloadFileCsv } from 'utils/arquivo';
import { duckCleanRelatorioTodosRequerimentos, duckRelatorioTodosRequerimentos } from 'store/ducks/relatorios';
import { fetchStatusModal } from './fetchApp';
import { ENUM_MODAL } from 'utils/consts';

export const fetchGetRelatorioGrafico = filtro => dispatch => {
  return new Promise((resolve, reject) => {
    const url = montarUrlFiltro(`Relatorio/resumido`, filtro);
    dispatch(getPadraoComRetorno(url))
      .then(res => resolve(res))
      .catch(error => reject(error));
  });
};

export const fetchDownloadRelatorioDetalhado = (filtro, nomeArquivo) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = montarUrlFiltro(`Relatorio/detalhado`, filtro);
    dispatch(getPadraoBlobComRetorno(url))
      .then(res => {
        downloadFileCsv(res, nomeArquivo);
        resolve(res);
      })
      .catch(error => reject(error));
  });
};

export const fetchGetRelatorioListarRequerimentosByFilter = (filtro, page, itemsByPage) => dispatch => {
  const url = montarUrlFiltro(`Relatorio/page=${page}&itemsByPage=${itemsByPage}`, filtro);
  dispatch(getPadraoComRetorno(url, true))
    .then(retorno => {
      dispatch(duckRelatorioTodosRequerimentos(retorno));
    })
    .catch(() => {
      dispatch(duckCleanRelatorioTodosRequerimentos());
    });
};

export const fetchGetHistoricoRelatorioRequerimentos = formularioId => dispatch => {
  const sucesso = retorno => {
    dispatch(
      fetchStatusModal(true, ENUM_MODAL.HISTORICO_RELATORIO_REQUERIMENTO, {
        dadosGrid: retorno,
        width: 'fit-content',
      })
    );
  };
  dispatch(getPadrao(`Relatorio/${formularioId}`, sucesso));
};

export const fetchDownloadRelatorioRequerimentos = (filtro, nomeArquivo) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = montarUrlFiltro(`Relatorio/Download`, filtro);
    dispatch(getPadraoBlobComRetorno(url))
      .then(res => {
        downloadFileCsv(res, nomeArquivo);
        resolve(res);
      })
      .catch(error => reject(error));
  });
};
